var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('svg',{staticClass:"rbi"},[_c('use',{attrs:{"xlink:href":"/static/assets/images/rbi-icon.svg#rbi-check"}})]),_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }